// utils/api.ts
import DiagnosticService from '../services/DiagnosticService';

const API_URL = window.APP_CONFIG?.apiUrl || window.location.origin;

export const api = {
  get: async (endpoint: string, params?: Record<string, string>): Promise<any> => {
    try {
      const url = new URL(`${API_URL}${endpoint}`);
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });
      }

      const response = await fetch(url.toString(), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'include',
      });

      return await response.json();
    } catch (error) {
      console.error('API GET Error:', error);
      DiagnosticService.logNetworkError(endpoint, error, { method: 'GET' });
      throw error;
    }
  },

  post: async (endpoint: string, body?: any): Promise<any> => {
    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'include',
      });

      return await response.json();
    } catch (error) {
      console.error('API POST Error:', error);
      DiagnosticService.logNetworkError(endpoint, error, { method: 'POST' });
      throw error;
    }
  },

  delete: async (endpoint: string, body?: any): Promise<any> => {
    try {
      const headers: Record<string, string> = { 'Accept': 'application/json' };
      if (body) headers['Content-Type'] = 'application/json';

      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'DELETE',
        headers,
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'include',
      });

      return await response.json();
    } catch (error) {
      console.error('API DELETE Error:', error);
      DiagnosticService.logNetworkError(endpoint, error, { method: 'DELETE' });
      throw error;
    }
  },

  patch: async (endpoint: string, body?: any): Promise<any> => {
    try {
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'include',
      });

      return await response.json();
    } catch (error) {
      console.error('API PATCH Error:', error);
      DiagnosticService.logNetworkError(endpoint, error, { method: 'PATCH' });
      throw error;
    }
  },
};
